import { configureStore } from '@reduxjs/toolkit';
import absenceReducer from '../slices/absenceSlice';
import actionsPermissionsReducer from '../slices/actionsPermissionsSlice';
import activityLogsReducer from '../slices/activityLogsSlice';
import authReducer from '../slices/authSlice';
import calendarReducer from '../slices/calendarSlice';
import delegationsReducer from "../slices/delegationSlice";
import documentationReducer from '../slices/documentLibrarySlice';
import messagesReducer from '../slices/messagesSlice';
import notificationsReducer from '../slices/notificationsSlice';
import organizationSettingsReducer from '../slices/organizationSettingsSlice';
import organizationDocumentsReducer from '../slices/organizationDocumentsSlice';
import officeLocationsReducer from '../slices/officeLocationsSlice';
import pausesReducer from '../slices/pausesSlice';
import presenceReducer from '../slices/presenceSlice';
import projectsReducer from "../slices/projectsSlice";
import rolesReducer from "../slices/rolesSlice";
import shiftsReducer from '../slices/shiftSlice';
import shiftTemplatesReducer from '../slices/shiftTemplateSlice';
import scheduleTypesReducer from '../slices/scheduleTypeSlice';
import statisticsReducer from '../slices/statisticsSlice';
import teamsReducer from "../slices/teamSlice";
import timeBalancesReducer from '../slices/timeBalanceSlice';
import toastReducer from '../slices/toastSlice';
import userReducer from '../slices/userSlice';
import workItemsReducer from '../slices/workItemsSlice';
import workTimeRegisterReducer from '../slices/workTimeRegisterSlice';
import workPackagesReducer from "../slices/workPackageSlice";
import timeDistributionReducer from "../slices/timeDistributionSlice";
const store = configureStore({
  reducer: {
    absences: absenceReducer,
    actions: actionsPermissionsReducer,
    activityLogs: activityLogsReducer,
    auth: authReducer,
    calendar: calendarReducer,
    delegations: delegationsReducer,
    documents: documentationReducer,
    messages: messagesReducer,
    notifications: notificationsReducer,
    organization: organizationSettingsReducer,
    organizationDocuments: organizationDocumentsReducer,
    officeLocations: officeLocationsReducer,
    pauses: pausesReducer,
    presences: presenceReducer,
    projects: projectsReducer,
    roles: rolesReducer,
    shifts: shiftsReducer,
    shiftTemplates: shiftTemplatesReducer,
    scheduleTypes: scheduleTypesReducer,
    statistics: statisticsReducer,
    teams: teamsReducer,
    timeBalances: timeBalancesReducer,
    workPackages: workPackagesReducer,
    timeDistribution: timeDistributionReducer,
    toast: toastReducer,
    users: userReducer,
    workItems: workItemsReducer,
    workTimeRegister: workTimeRegisterReducer,
  },
});

export default store;
